import { Component, OnInit, ViewChild } from '@angular/core';
import { NbSidebarComponent } from '@nebular/theme';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout windowMode>
      <nb-layout-header fixed>
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-sidebar 
        #sidebar
        class="menu-sidebar" 
        tag="menu-sidebar" 
        responsive 
        responsiveState="compacted"
        [fixed]="false"
        state="expanded">
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <nb-layout-column>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent implements OnInit {
  @ViewChild('sidebar') sidebar: NbSidebarComponent;

  ngOnInit() {
    // Ensure sidebar is properly initialized on load
    if (this.sidebar) {
      this.sidebar.responsive = true;
    }
  }
}
